export const clsx = (...classes: (string | undefined)[]) => {
  return classes.filter(c => c).join(' ')
}
